import axios from 'axios';
import {
  FETCH_WEBHOOK_CONFIG,
  CREATE_WEBHOOK_CONFIG,
  UPDATE_WEBHOOK_CONFIG,
  DELETE_WEBHOOK_CONFIG,
  SET_WEBHOOK_LOADING,
  SET_WEBHOOK_ERROR
} from './type';

const BASE_URL = process.env.REACT_APP_PORT;
const head = {
      headers: {
        'x-auth-token': localStorage.getItem('token')
      }
    };

// Fetch Webhook Config (by user ID — user is inferred from token on backend)
export const fetchWebhookConfig = () => async dispatch => {
  dispatch({ type: SET_WEBHOOK_LOADING });
  try {
    const res = await axios.get(`${BASE_URL}/api/ai/webhook-config`,head);
    dispatch({ type: FETCH_WEBHOOK_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_WEBHOOK_ERROR, payload: err.message });
    return null;
  }
};

// Create Webhook Config
export const createWebhookConfig = data => async dispatch => {
  dispatch({ type: SET_WEBHOOK_LOADING });
  try {
    const res = await axios.post(`${BASE_URL}/api/ai/webhook-config`, data,head);
    dispatch({ type: CREATE_WEBHOOK_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_WEBHOOK_ERROR, payload: err.message });
    return null;
  }
};

// Update Webhook Config
export const updateWebhookConfig = (id, data) => async dispatch => {
  dispatch({ type: SET_WEBHOOK_LOADING });
  try {
    const res = await axios.put(`${BASE_URL}/api/ai/webhook-config`, data,head);
    dispatch({ type: UPDATE_WEBHOOK_CONFIG, payload: res.data.data });
    return res.data.data;
  } catch (err) {
    dispatch({ type: SET_WEBHOOK_ERROR, payload: err.message });
    return null;
  }
};

// ✅ Delete Webhook Config
export const deleteWebhookConfig = () => async dispatch => {
  dispatch({ type: SET_WEBHOOK_LOADING });
  try {
    const res = await axios.delete(`${BASE_URL}/api/ai/webhook-config`, head);
    dispatch({ type: DELETE_WEBHOOK_CONFIG });
    return res.data;
  } catch (err) {
    dispatch({ type: SET_WEBHOOK_ERROR, payload: err.message });
    return null;
  }
};

